export default __webpack_public_path__ + "static/resources/policy/Экологическая_политика.doc";